import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
import { useLanguageStore } from '../store/languageStore';

const translations = {
  EN: {
    title: "Trusted by Professionals",
    subtitle: "See what healthcare professionals and emergency responders are saying about RightNowAid.",
    testimonials: [
      {
        quote: "RightNowAid helped me stay calm and focused during a medical emergency. The step-by-step guidance was invaluable.",
        author: "Sarah Johnson",
        role: "Medical Professional",
        image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&h=256&q=80",
      },
      {
        quote: "As a first responder, I've seen how RightNowAid has helped people get the help they need faster. It's a game-changer.",
        author: "Michael Chen",
        role: "Emergency Responder",
        image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&h=256&q=80",
      },
      {
        quote: "The AI's ability to understand and respond to emergency situations is remarkable. It's like having a professional by your side.",
        author: "Dr. Emily Rodriguez",
        role: "Healthcare Provider",
        image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&h=256&q=80",
      },
    ],
  },
  ES: {
    title: "Confiado por Profesionales",
    subtitle: "Vea lo que los profesionales de la salud y los respondedores de emergencia dicen sobre RightNowAid.",
    testimonials: [
      {
        quote: "RightNowAid me ayudó a mantener la calma y el enfoque durante una emergencia médica. La guía paso a paso fue invaluable.",
        author: "Sarah Johnson",
        role: "Profesional Médico",
        image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&h=256&q=80",
      },
      {
        quote: "Como respondedor de emergencias, he visto cómo RightNowAid ha ayudado a las personas a obtener la ayuda que necesitan más rápido. Es un cambio de juego.",
        author: "Michael Chen",
        role: "Respondedor de Emergencias",
        image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&h=256&q=80",
      },
      {
        quote: "La capacidad de la IA para comprender y responder a situaciones de emergencia es notable. Es como tener un profesional a tu lado.",
        author: "Dra. Emily Rodriguez",
        role: "Proveedora de Salud",
        image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&h=256&q=80",
      },
    ],
  },
  ZH: {
    title: "专业人士的信赖",
    subtitle: "看看医疗专业人士和紧急救援人员对RightNowAid的评价。",
    testimonials: [
      {
        quote: "RightNowAid帮助我在医疗紧急情况下保持冷静和专注。一步一步的指导非常宝贵。",
        author: "Sarah Johnson",
        role: "医疗专业人士",
        image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&h=256&q=80",
      },
      {
        quote: "作为第一响应者，我亲眼目睹了RightNowAid如何帮助人们更快地获得所需帮助。这是一个改变游戏规则的工具。",
        author: "Michael Chen",
        role: "紧急救援人员",
        image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&h=256&q=80",
      },
      {
        quote: "AI理解和应对紧急情况的能力令人印象深刻。就像有一位专业人士在你身边。",
        author: "Emily Rodriguez医生",
        role: "医疗保健提供者",
        image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&h=256&q=80",
      },
    ],
  },
  VI: {
    title: "Được Tin Tưởng Bởi Chuyên Gia",
    subtitle: "Xem các chuyên gia y tế và người ứng phó khẩn cấp nói gì về RightNowAid.",
    testimonials: [
      {
        quote: "RightNowAid đã giúp tôi giữ bình tĩnh và tập trung trong tình huống khẩn cấp y tế. Hướng dẫn từng bước vô cùng quý giá.",
        author: "Sarah Johnson",
        role: "Chuyên Gia Y Tế",
        image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&h=256&q=80",
      },
      {
        quote: "Là người ứng phó đầu tiên, tôi đã thấy RightNowAid giúp mọi người nhận được sự trợ giúp họ cần nhanh hơn như thế nào. Đây là một bước ngoặt.",
        author: "Michael Chen",
        role: "Người Ứng Phó Khẩn Cấp",
        image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&h=256&q=80",
      },
      {
        quote: "Khả năng của AI trong việc hiểu và phản hồi tình huống khẩn cấp thật đáng kinh ngạc. Giống như có một chuyên gia bên cạnh bạn.",
        author: "Bác sĩ Emily Rodriguez",
        role: "Nhà Cung Cấp Y Tế",
        image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&h=256&q=80",
      },
    ],
  },
  FIL: {
    title: "Pinagkakatiwalaan ng mga Propesyonal",
    subtitle: "Tingnan kung ano ang sinasabi ng mga healthcare professional at emergency responder tungkol sa RightNowAid.",
    testimonials: [
      {
        quote: "Tumulong sa akin ang RightNowAid na manatiling kalmado at nakatuon sa panahon ng medical emergency. Napakahalaga ng step-by-step na gabay.",
        author: "Sarah Johnson",
        role: "Medical Professional",
        image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&h=256&q=80",
      },
      {
        quote: "Bilang first responder, nakita ko kung paano tinulungan ng RightNowAid ang mga tao na makuha ang tulong na kailangan nila nang mas mabilis. Ito ay isang game-changer.",
        author: "Michael Chen",
        role: "Emergency Responder",
        image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&h=256&q=80",
      },
      {
        quote: "Ang kakayahan ng AI na maunawaan at tumugon sa mga emergency situation ay kahanga-hanga. Para kang may propesyonal sa tabi mo.",
        author: "Dr. Emily Rodriguez",
        role: "Healthcare Provider",
        image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&h=256&q=80",
      },
    ],
  },
  KO: {
    title: "전문가들이 신뢰하는 서비스",
    subtitle: "의료 전문가와 비상 대응자들이 RightNowAid에 대해 말하는 것을 확인하세요.",
    testimonials: [
      {
        quote: "RightNowAid는 의료 비상 상황에서 침착함과 집중력을 유지하는 데 도움이 되었습니다. 단계별 안내는 매우 귀중했습니다.",
        author: "Sarah Johnson",
        role: "의료 전문가",
        image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&h=256&q=80",
      },
      {
        quote: "첫 대응자로서, RightNowAid가 사람들이 필요한 도움을 더 빨리 받을 수 있도록 도운 것을 목격했습니다. 이는 게임 체인저입니다.",
        author: "Michael Chen",
        role: "비상 대응자",
        image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&h=256&q=80",
      },
      {
        quote: "AI가 비상 상황을 이해하고 대응하는 능력은 놀랍습니다. 마치 전문가가 곁에 있는 것 같습니다.",
        author: "Emily Rodriguez 박사",
        role: "의료 서비스 제공자",
        image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&h=256&q=80",
      },
    ],
  },
  AR: {
    title: "موثوق به من قبل المتخصصين",
    subtitle: "شاهد ما يقوله المتخصصون في الرعاية الصحية والمستجيبون للطوارئ عن RightNowAid.",
    testimonials: [
      {
        quote: "ساعدني RightNowAid في الحفاظ على الهدوء والتركيز أثناء حالة طوارئ طبية. كان التوجيه خطوة بخطوة لا يقدر بثمن.",
        author: "Sarah Johnson",
        role: "متخصص طبي",
        image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&h=256&q=80",
      },
      {
        quote: "كمستجيب أول، رأيت كيف ساعد RightNowAid الناس في الحصول على المساعدة التي يحتاجونها بشكل أسرع. إنه يغير قواعد اللعبة.",
        author: "Michael Chen",
        role: "مستجيب للطوارئ",
        image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&h=256&q=80",
      },
      {
        quote: "قدرة الذكاء الاصطناعي على فهم والاستجابة لحالات الطوارئ رائعة. إنه مثل وجود محترف بجانبك.",
        author: "الدكتورة Emily Rodriguez",
        role: "مقدمة رعاية صحية",
        image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&h=256&q=80",
      },
    ],
  },
};

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
    },
  },
};

export const Testimonials = () => {
  const { selectedLanguage } = useLanguageStore();
  const t = translations[selectedLanguage];

  return (
    <section className="relative py-24 sm:py-32">
      <div className="container mx-auto px-4">
        <div className="mx-auto max-w-2xl text-center">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl"
          >
            {t.title}
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="mt-4 text-lg text-muted-foreground"
          >
            {t.subtitle}
          </motion.p>
        </div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="mt-16 grid gap-8 sm:grid-cols-2 lg:grid-cols-3"
        >
          {t.testimonials.map((testimonial) => (
            <motion.div
              key={testimonial.author}
              variants={itemVariants}
              className="group relative rounded-2xl border border-border bg-card p-6 shadow-sm transition-all hover:shadow-md"
            >
              <Quote className="mb-4 h-8 w-8 text-primary/50" />
              <blockquote className="mb-6 text-lg text-foreground">
                "{testimonial.quote}"
              </blockquote>
              <div className="flex items-center gap-4">
                <img
                  src={testimonial.image}
                  alt={testimonial.author}
                  className="h-12 w-12 rounded-full object-cover"
                />
                <div>
                  <div className="font-semibold text-foreground">
                    {testimonial.author}
                  </div>
                  <div className="text-sm text-muted-foreground">
                    {testimonial.role}
                  </div>
                </div>
              </div>
              <div className="absolute inset-0 rounded-2xl border-2 border-primary/0 transition-colors group-hover:border-primary/20" />
            </motion.div>
          ))}
        </motion.div>
      </div>

      {/* Background Elements */}
      <div className="absolute inset-0 -z-10 bg-grid-white/[0.02] bg-[size:20px_20px]" />
      <div className="absolute inset-0 -z-10 bg-gradient-to-t from-background via-background/80 to-transparent" />
    </section>
  );
}; 